import "./text-image-block.component.css"
import { Remarkable } from "remarkable"
import StrapiImageComponent from "../strapi-image/strapi-image.component"

const TextImageBlockComponent = (props) => {
  const { id, Heading, Subheading, Body, Media } = props
  const md = new Remarkable()

  return (
    <div className={`dagger-text-image-block dagger-text-image-block-${id}`}>
      <h2>{Heading}</h2>
      {Subheading && (
        <h3
          dangerouslySetInnerHTML={{
            __html: md.render(Subheading),
          }}
        />
      )}
      {Body && (
        <div className="dagger-text-image-block-main">
          <p
            dangerouslySetInnerHTML={{
              __html: md.render(Body),
            }}
          />
          {Media?.data && (
            <StrapiImageComponent attributes={Media.data.attributes} sizes="(max-width: 600px) 60vw, 40vw" />
          )}
        </div>
      )}
    </div>
  )
}

export default TextImageBlockComponent
